import React, { useState, useEffect, useRef } from 'react';
import ModalInfoPatient from './ModalInfoPatient';
import ModalEditPatient from './ModalEditPatient';
import ModalExtraction from './ModalExtraction';
import ModalConvPatient from './ModalConvPatient';


function Chat({ API_URL, token, convActive, patientActif, onPatientUpdate }) {
    const [messages, setMessages]           = useState([]);
    const [input, setInput]                 = useState('');
    const [loading, setLoading]             = useState(false);
    const [modalInfo, setModalInfo]         = useState(false);
    const [modalEdit, setModalEdit]         = useState(false);
    const [modalExtraction, setModalExtraction] = useState(false);
    const messagesEndRef                    = useRef(null);
    const [modalHistorique, setModalHistorique] = useState(false);
    const [isRecording, setIsRecording]         = useState(false);

    useEffect(() => {
        if (convActive) chargerMessages();
    }, [convActive]);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages, loading]);

    async function chargerMessages() {
        const res  = await fetch(`${API_URL}/conversations/${convActive}/messages`,
            { headers: { Authorization: `Bearer ${token}`, "ngrok-skip-browser-warning": "true" } });
        const data = await res.json();
        setMessages(data);
    }

    async function envoyerMessage() {
        const contenu = input.trim();
        if (!contenu || !convActive) return;
        setInput('');
        setMessages(prev => [...prev, { role: 'user', contenu }]);
        setLoading(true);
        try {
            const res  = await fetch(`${API_URL}/conversations/${convActive}/messages`, {
                method : 'POST',
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "true" },
                body   : JSON.stringify({ contenu })
            });
            const data = await res.json();
            setMessages(prev => [...prev, { role: 'assistant', contenu: data.reponse }]);
        } catch(e) {
            setMessages(prev => [...prev, { role: 'assistant', contenu: "Erreur de connexion avec l'agent." }]);
        }
        setLoading(false);
    }

    function formaterContenu(role, contenu) {
        if (role === 'user') return contenu;
        return contenu
            .replace(/[*][*](.*?)[*][*]/g, '<strong>$1</strong>')
            .replace(/[*](.*?)[*]/g, '<em>$1</em>')
            .replace(/\\n/g, '<br>')
            .replace(/\n/g, '<br>');
    }

    const infoStr = patientActif ? [
        patientActif.age  ? `${patientActif.age} ans` : '',
        patientActif.sexe === 'M' ? 'Homme' : patientActif.sexe === 'F' ? 'Femme' : '',
        patientActif.telephone || ''
    ].filter(Boolean).join(' · ') : '';

    const btnStyle = {
        background: 'transparent', border: '1px solid var(--border)',
        color: 'var(--text-muted)', padding: '6px 12px',
        borderRadius: '8px', cursor: 'pointer',
        fontSize: '12px', flexShrink: 0,
        marginLeft: '8px', whiteSpace: 'nowrap'
    };

    function toggleMicro() {
        if (isRecording) {
            setIsRecording(false);
            if (window._recognition) window._recognition.stop();
            return;
        }
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) { alert("Votre navigateur ne supporte pas la reconnaissance vocale."); return; }
        setIsRecording(true);
        const recognition          = new SpeechRecognition();
        window._recognition        = recognition;
        recognition.lang           = 'fr-FR';
        recognition.continuous     = true;
        recognition.interimResults = true;
        let texteAccumule = "";
        recognition.onresult = (event) => {
            let texteFinal = texteAccumule, texteInterim = "";
            for (let i = event.resultIndex; i < event.results.length; i++) {
                if (event.results[i].isFinal) {
                    texteFinal   += event.results[i][0].transcript + " ";
                    texteAccumule = texteFinal;
                } else { texteInterim += event.results[i][0].transcript; }
            }
            setInput(texteFinal + texteInterim);
        };
        recognition.onend = () => {
            if (isRecording) recognition.start();
        };
        recognition.onerror = (event) => {
            if (event.error === "no-speech") return;
            setIsRecording(false);
        };
        recognition.start();
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden' }}>

            {/* Header */}
            <div style={{
                padding: '16px 24px', borderBottom: '1px solid var(--border)',
                display: 'flex', alignItems: 'center',
                justifyContent: 'space-between', flexShrink: 0
            }}>
                <div style={{ minWidth: 0, flex: 1, overflow: 'hidden' }}>
                    <div style={{ fontSize: '14px', fontWeight: 500, color: 'var(--text)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {patientActif?.prenom} {patientActif?.nom}
                    </div>
                    {infoStr && (
                        <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>
                            {infoStr}
                        </div>
                    )}
                </div>
                <button className="btn-header-chat" style={btnStyle} onClick={() => setModalHistorique(true)}>📋 Historique</button>
                <button className="btn-header-chat" style={btnStyle} onClick={() => setModalInfo(true)}>ℹ️ Info</button>
                <button className="btn-header-chat" style={btnStyle} onClick={() => setModalEdit(true)}>✏️ Modifier</button>
            </div>

            {/* Messages */}
            <div style={{
                flex: 1, overflowY: 'auto', padding: '32px 24px',
                display: 'flex', flexDirection: 'column',
                gap: '20px', minHeight: 0
            }}>
                {messages.map((msg, i) => (
                    <div
                        key          = {i}
                        style={{
                            display      : 'flex',
                            gap          : '12px',
                            maxWidth     : '75%',
                            alignSelf    : msg.role === 'user' ? 'flex-end' : 'flex-start',
                            flexDirection: msg.role === 'user' ? 'row-reverse' : 'row'
                        }}
                    >
                        <div style={{
                            width: '32px', height: '32px', borderRadius: '50%',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '11px', fontWeight: 600, flexShrink: 0,
                            background: 'var(--bg-light)', border: '1px solid var(--border)',
                            color: 'var(--text-muted)'
                        }}>
                            {msg.role === 'user' ? 'Dr' : 'IA'}
                        </div>
                        <div
                            style={{
                                padding    : '12px 16px', borderRadius: '12px',
                                fontSize   : '14px', lineHeight: 1.65,
                                wordBreak  : 'break-word',
                                background : msg.role === 'user' ? 'var(--white)' : 'var(--bg-light)',
                                color      : msg.role === 'user' ? '#1a1a1a' : 'var(--text)',
                                border     : msg.role === 'assistant' ? '1px solid var(--border)' : 'none',
                                borderBottomRightRadius: msg.role === 'user' ? '4px' : '12px',
                                borderBottomLeftRadius : msg.role === 'assistant' ? '4px' : '12px',
                                whiteSpace : msg.role === 'user' ? 'pre-wrap' : 'normal'
                            }}
                            dangerouslySetInnerHTML={{ __html: formaterContenu(msg.role, msg.contenu) }}
                        />
                    </div>
                ))}

                {/* Typing indicator */}
                {loading && (
                    <div style={{ display: 'flex', gap: '12px', maxWidth: '75%', alignSelf: 'flex-start' }}>
                        <div style={{
                            width: '32px', height: '32px', borderRadius: '50%',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '11px', fontWeight: 600, background: 'var(--bg-light)',
                            border: '1px solid var(--border)', color: 'var(--text-muted)'
                        }}>IA</div>
                        <div style={{
                            display: 'flex', gap: '5px', padding: '14px 16px',
                            background: 'var(--bg-light)', border: '1px solid var(--border)',
                            borderRadius: '12px', borderBottomLeftRadius: '4px'
                        }}>
                            {[0, 0.2, 0.4].map((delay, i) => (
                                <span key={i} style={{
                                    width: '7px', height: '7px',
                                    background: 'var(--text-muted)', borderRadius: '50%',
                                    display: 'inline-block',
                                    animation: `bounce 1.2s ${delay}s infinite`
                                }}/>
                            ))}
                        </div>
                    </div>
                )}
                <div ref={messagesEndRef} />
            </div>

            {/* Zone saisie */}
            <div style={{
                padding    : '16px 24px',
                borderTop  : '1px solid var(--border)',
                display    : 'flex',
                gap        : '10px',
                alignItems : 'flex-end',
                flexShrink : 0,
                background : 'var(--bg)'
            }}>
                <textarea
                    value       = {input}
                    onChange    = {e => {
                        setInput(e.target.value);
                        e.target.style.height = 'auto';
                        e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
                    }}
                    onKeyDown   = {e => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            envoyerMessage();
                        }
                    }}
                    placeholder = "Décrivez les symptômes du patient..."
                    rows        = {1}
                    style={{
                        flex          : 1,
                        padding       : '11px 16px',
                        background    : 'var(--bg-light)',
                        border        : '1px solid var(--border)',
                        borderRadius  : '10px',
                        color         : 'var(--text)',
                        fontSize      : '14px',
                        outline       : 'none',
                        resize        : 'none',
                        lineHeight    : '1.5',
                        fontFamily    : 'inherit',
                        minWidth      : 0,
                        height        : '44px',
                        maxHeight     : '120px',
                        overflowY     : 'auto',
                        display       : 'block'
                    }}
                />
                <button
                    className="btn-saisie"
                    onClick = {() => setModalExtraction(true)}
                    style={{
                        padding      : '11px 14px',
                        background   : 'transparent',
                        color        : 'var(--text-muted)',
                        border       : '1px solid var(--border)',
                        borderRadius : '10px',
                        cursor       : 'pointer',
                        fontSize     : '16px',
                        lineHeight   : 1,
                        flexShrink   : 0
                    }}
                >📎</button>
                <button
                    className="btn-saisie"
                    onClick = {toggleMicro}
                    style={{
                        padding      : '11px 14px',
                        background   : isRecording ? '#e06c6c' : 'transparent',
                        color        : isRecording ? 'white' : 'var(--text-muted)',
                        border       : isRecording ? '1px solid #e06c6c' : '1px solid var(--border)',
                        borderRadius : '10px',
                        cursor       : 'pointer',
                        fontSize     : '16px',
                        lineHeight   : 1,
                        flexShrink   : 0
                    }}
                >{isRecording ? '⏹' : '🎤'}</button>
                <button
                    className="btn-envoyer-mobile"
                    onClick  = {envoyerMessage}
                    disabled = {loading}
                    style={{
                        padding      : '11px 16px',
                        background   : 'var(--white)',
                        color        : '#1a1a1a',
                        border       : 'none',
                        borderRadius : '10px',
                        cursor       : loading ? 'not-allowed' : 'pointer',
                        fontSize     : '16px',
                        lineHeight   : 1,
                        flexShrink   : 0,
                        opacity      : loading ? 0.3 : 1
                    }}
                >↑</button>
            </div>

            {/* Modals */}
            {modalInfo && (
                <ModalInfoPatient
                    patient  = {patientActif}
                    onFermer = {() => setModalInfo(false)}
                />
            )}

            {modalEdit && (
                <ModalEditPatient
                    API_URL      = {API_URL}
                    token        = {token}
                    patient      = {patientActif}
                    onFermer     = {() => setModalEdit(false)}
                    onSauvegarder = {p => {
                        onPatientUpdate(p);
                        setModalEdit(false);
                    }}
                />
            )}

            {modalExtraction && (
                <ModalExtraction
                    API_URL  = {API_URL}
                    token    = {token}
                    onFermer = {() => setModalExtraction(false)}
                    onAjouter = {texte => {
                        const actuel = input.trim();
                        setInput(actuel ? actuel + '\n\n📄 Données du document :\n' + texte : '📄 Données du document :\n' + texte);
                        setModalExtraction(false);
                    }}
                />
            )}

            {modalHistorique && (
                <ModalConvPatient
                    API_URL      = {API_URL}
                    token        = {token}
                    patient      = {patientActif}
                    onFermer     = {() => setModalHistorique(false)}
                    onOuvrirConv = {(convId, patient) => {
                        setModalHistorique(false);
                    }}
                />
            )}

            <style>{`
                @keyframes bounce {
                    0%, 60%, 100% { transform: translateY(0); opacity: 0.6; }
                    30% { transform: translateY(-5px); opacity: 1; }
                }
            `}</style>
        </div>
    );
}

export default Chat;